/* global axios */
// store/modules/staffOptions.js

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

const state = {
  options: [],
  isLoading: false,
  isError: false,

  pagination: {
    page: 1,
    page_size: 10,
    total: 0,
    next: null,
  },

  filters: {
    q: null,
    branch_id: null,
    service_id: null,
    active: null,
    enabled: true,
  },

  allOptions: [],
  isAllLoading: false,
  isAllError: false,
};

const getters = {
  options: state => state.options,
  pagination: state => state.pagination,
  filters: state => state.filters,

  formattedPagination: (state) => {
    const { page, total, page_size } = state.pagination;
    return {
      currentPage: page,
      totalPages: Math.max(1, Math.ceil(total / page_size)),
      pageSize: page_size,
    };
  },
};

const mutations = {
  SET_OPTIONS(state, options) { state.options = options; },
  SET_LOADING(state, v) { state.isLoading = v; },
  SET_ERROR(state, v) { state.isError = v; },
  SET_FILTERS(state, filters) { state.filters = { ...state.filters, ...filters }; },
  SET_PAGINATION(state, pagination) { state.pagination = { ...state.pagination, ...pagination }; },
  RESET(state) {
    state.options = [];
    state.pagination = { page: 1, page_size: 10, total: 0, next: null };
    state.filters = { q: null, branch_id: null, active: null, enabled: true };
    state.allOptions = [];
    state.isAllLoading = false;
    state.isAllError = false;
  },
  SET_ALL_OPTIONS(state, options) { state.allOptions = options; },
  SET_ALL_LOADING(state, v) { state.isAllLoading = v; },
  SET_ALL_ERROR(state, v) { state.isAllError = v; }
};

const actions = {
  async fetchOptions({ state, commit, rootGetters }) {
    const accountId = rootGetters.getCurrentAccountId;
    try {
      commit('SET_LOADING', true);
      commit('SET_ERROR', false);

      const { q, service_id, branch_id, active, enabled } = state.filters;

      const res = await axios.get(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/staff`),
        {
          params: {
            q, service_id, branch_id, active, enabled,
            page: state.pagination.page,
            page_size: state.pagination.page_size,
          },
        }
      );

      const { results, page, total, next } = res.data;
      commit('SET_OPTIONS', results);
      commit('SET_PAGINATION', { page, total, next });

      return results;
    } catch (err) {
      commit('SET_ERROR', true);
      throw err.response?.data || err;
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async updateFiltersAndFetch({ commit, dispatch }, filters) {
    commit('SET_FILTERS', filters);
    commit('SET_PAGINATION', { page: 1 });
    return dispatch('fetchOptions');
  },

  async updatePaginationAndFetch({ commit, dispatch }, pagination) {
    commit('SET_PAGINATION', pagination);
    return dispatch('fetchOptions');
  },

  reset({ commit }) {
    commit('RESET');
  },

  async fetchAllOptions({ state, commit, rootGetters }) {
    const accountId = rootGetters.getCurrentAccountId;
    try {
      commit('RESET');
      commit('SET_ALL_LOADING', true);
      commit('SET_ALL_ERROR', false);

      const { q, service_id, branch_id, active, enabled } = state.filters;
      const allResults = [];
      const pageSize = 100;

      const firstRes = await axios.get(
        knowledgeProxy(accountId, `/v2/accounts/${accountId}/staff`),
        { params: { q, service_id, branch_id, active, enabled, page: 1, page_size: pageSize } }
      );

      const { results: firstResults, total } = firstRes.data;

      if (Array.isArray(firstResults)) {
        allResults.push(...firstResults);
      }

      const totalPages = Math.ceil(total / pageSize);

      for (let page = 2; page <= totalPages; page++) {
        const res = await axios.get(
          knowledgeProxy(accountId, `/v2/accounts/${accountId}/staff`),
          { params: { q, service_id, branch_id, active, enabled, page, page_size: pageSize } }
        );

        if (Array.isArray(res.data.results)) {
          allResults.push(...res.data.results);
        }
      }

      commit('SET_ALL_OPTIONS', allResults);
      return allResults;
    } catch (err) {
      commit('SET_ALL_ERROR', true);
      throw err.response?.data || err;
    } finally {
      commit('SET_ALL_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
